import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-subtitle',
  templateUrl: './subtitle.component.html',
})
export class SubtitleComponent extends FieldWrapper {}
